export const CONSTANT = {
  //加班情况
  OVERTIME_TYPE: {
    1: "不加班",
    2: "偶尔加班",
    3: "弹性工作",
  },
  //休息时间
  REST_TYPE: {
    1: "双休",
    2: "单休",
    3: "大小周",
    4: "排版轮休",
  },
  //举报类型
  REPORT_TYPE: {
    //企业
    COMPANY: "0",
    //职位
    POSITION: "1",
  },
}
